<div class="tsd_container equipment-form-dialog">
  <form [formGroup]="equipmentForm">
    <mat-card>
      <mat-card-content>
        <h4>{{id.value?'Edit':'Add'}} Equipment </h4>
        <mat-form-field class="mat-width">
          <mat-label>Equipment Name</mat-label>
          <input matInput formControlName="name" autocomplete="off" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Equipment Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>Equipment Code</mat-label>
          <input matInput formControlName="code" autocomplete="off" maxlength="2" required>
          @if (code.touched && code.invalid && code.hasError('required')) {
            <mat-error>Equipment Code is required</mat-error>
          }
          @if (code.touched && code.invalid && (code.hasError('minlength') || code.hasError('maxlength'))) {
            <mat-error>Equipment Code should be of 2 Characters</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>Equipment Type</mat-label>
          <mat-select formControlName="type" required>
            <mat-option [value]="null">None</mat-option>
            @for (type of equipmentTypes; track type) {
              <mat-option  [value]="type">
                {{type}}
              </mat-option>
            }
          </mat-select>
          @if (type.touched && type.invalid && type.hasError('required')) {
            <mat-error>Equipment Type is required</mat-error>
          }
        </mat-form-field>
        <mat-card-actions>
          <button mat-button color="cancel" (click)="Cancel()">CANCEL</button>
          <button mat-button color="primary" (click)="Save()" [disabled]="(!editPermission && id.value) || (!addPermission && !id.value)">SAVE</button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>
</div>
